import { render, staticRenderFns } from "./novelMiniprogramforms.vue?vue&type=template&id=3f6bdf9f&scoped=true"
import script from "./novelMiniprogramforms.vue?vue&type=script&lang=js"
export * from "./novelMiniprogramforms.vue?vue&type=script&lang=js"
import style0 from "./novelMiniprogramforms.vue?vue&type=style&index=0&id=3f6bdf9f&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../../../../../../opt/build-cache/ad/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f6bdf9f",
  null
  
)

export default component.exports